import { QueryFunctionContext, useQuery } from "@tanstack/react-query";

export const TEXT_STATISTICS_QUERY_KEY = "text-statistics";

export function useTextStatistics() {
  const query = useQuery({
    queryFn: fetchStatistics,
    queryKey: [TEXT_STATISTICS_QUERY_KEY],
  });

  return query;
}

type Statistics = {
  average_views: number;
  total_views: number;
  max_views: number;
  total_created_texts: number;
  total_created_texts_length: number;
  last_week_created_texts: number;
  last_four_weeks_created_texts: number;
};

async function fetchStatistics(ctx: QueryFunctionContext): Promise<Statistics> {
  const res = await fetch(`/api/reeprise/generated_texts/stats/`, {
    signal: ctx.signal,
  });
  if (!res.ok) {
    throw new Error("could not fetch text statistics");
  }
  return (await res.json()) as Statistics;
}
